// extracted by css-extract-rspack-plugin
export default {"checkNameButton":"XPBgMJcid9QmzULJ"};